export const Types = {
  ADD_EXTRATO_PAGO: "filtrosExtratoPago/ADD_EXTRATO_PAGO",
  SET_FILTRO: "filtrosExtratoPago/SET_FILTRO"
};

const INITIAL_STATE = {
  fl: [],
  tipo: [],
  initial_date: new Date(new Date().getFullYear(), new Date().getMonth()),
  finish_date: new Date(),
  openFiltro: true,
  stores_filter: [],
  users_filter: []
};

export default function filtrosExtratoPago(state = INITIAL_STATE, action) {
  switch (action.type) {
    case Types.ADD_EXTRATO_PAGO:
      return {
        ...state,
        fl: action.payload.data.fl,
        tipo: action.payload.data.tipo,
        initial_date: action.payload.data.initial_date,
        finish_date: action.payload.data.finish_date,
        stores_filter: action.payload.data.stores_filter,
        users_filter: action.payload.data.users_filter
      };
    case Types.CLOSE:
      return { ...state, open: false };
    case Types.SET_FILTRO:
      return { ...state, openFiltro: action.payload.data };
    default:
      return state;
  }
}

export const Creators = {
  addExtratoPagoFiltro: data => ({
    type: Types.ADD_EXTRATO_PAGO,
    payload: { data }
  }),
  setFiltro: data => ({
    type: Types.SET_FILTRO,
    payload: { data }
  })
};



// WEBPACK FOOTER //
// ./src/store/ducks/filtrosExtratoPago.js